import service from '@/services/types/unidadMedida'

// export const namespaced = true;

export const state = () => ({
  listProducto: [],
  listServicio: [],
  list: []
})

export const mutations = {
  LIST_SERVICIO: (state, objs) => (state.listServicio = objs),
  LIST_PRODUCTO: (state, objs) => (state.listProducto = objs),
  LIST: (state, objs) => (state.list = objs)
}

export const actions = {
  list: ({ commit, state }) =>
    state.list.length === 0
      ? service.list().then(result => {
          commit('LIST', result)
          return result
        })
      : state.list,

  listByClasificacion: ({ dispatch }, clasificacion) => (clasificacion === 'producto' ? dispatch('listProducto') : dispatch('listServicio')),

  listServicio: ({ commit, state }) =>
    state.listServicio.length === 0
      ? service.listServicio().then(result => {
          commit('LIST_SERVICIO', result)
          return result
        })
      : state.listServicio,

  listProducto: ({ commit, state }) =>
    state.listProducto.length === 0
      ? service.listProducto().then(result => {
          commit('LIST_PRODUCTO', result)
          return result
        })
      : state.listProducto
}

export const getters = {
  getUnidadProductoId: state => annotation =>
    state.listProducto.length !== 0 ? state.listProducto.find(item => item.annotation === annotation).id : null,
  getUnidadServicioId: state => annotation =>
    state.listServicio.length !== 0 ? state.listServicio.find(item => item.annotation === annotation).id : null,

  getUnidad: state => annotation => state.listProducto.length !== 0 ? state.listProducto.find(item => item.annotation === annotation) : null,
  getUnidadById: state => id => state.listProducto.length !== 0 ? state.listProducto.find(item => item.id === id) : null
}
